import { useState, useCallback, useEffect } from "react";
import useGet from "../read/useGet";
import { debounce } from "lodash";

const useTripDrivers = () => {
  // State for pagination
  const [pageNo, setPageNo] = useState(0);
  // State for search query
  const [searchQuery, setSearchQuery] = useState("");
  
  // Initial params for API call
  const initialParams = {
    page_number: 0,
    limit: 10
  };
  
  // Fetch drivers list
  const {
    list: driversData,
    paramsObject,
    setGetListParams
  } = useGet({
    url: "trip/driver_listing",
    method: "get",
    initialData: initialParams,
  });
  
  // Get loading state from driversData similar to useLeaveStructure
  const isDriversDataLoading = driversData?.isLoading;
  
  // Handle page change for pagination
  const handlePageClick = (val) => {
    const data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setPageNo(val.selected);
    setGetListParams(data);
  };

  // Create a debounced function for search API call
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((query) => {
      const data = {
        ...paramsObject,
        page_number: 0,
        search_query: query
      };
      setPageNo(0);
      setGetListParams(data);
    }, 500),
    [paramsObject]
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    debouncedSearch(query);
  };

  return {
    // States
    driversData,
    isLoading: isDriversDataLoading,
    pageNo,
    paramsObject,
    searchQuery,
    
    // Functions
    handlePageClick,
    handleSearchChange,
    setGetListParams,
  };
};

export default useTripDrivers;
